/**
 * Sets and updates height of related content non-slider containers.
 * Keeps the related content non-slider containers in place when hovering on a card.
 */

import _ from 'lodash';

const updateHeightOfRelatedContent = () => {
	// get all related content non-slider containers
	const getNonSliderContainers = () => {
		const nonSliderBlocks = Array.from(document.querySelectorAll('.related-content:not(:has(.swiper-initialized))'));
		
		if (!nonSliderBlocks.length) return [];

		let elements = [];

		nonSliderBlocks.forEach(block => {
			const sliderContainer = block.querySelector('.related-content__list');
			elements.push(sliderContainer);
		});

		return elements;
	}

	const setHeight = (element, card) => {
		if (!card) return;
		// set height of the cards container
		const height = card.offsetHeight;
		element.style.height = `${height}px`;
	};

	const unSetHeight = (element) => {
		// unset height of the cards container
		element.style.height = '';
	};

	const breakpointMatches = () => {
		// check if we're on tablet or desktop
		const breakpoint = window.matchMedia( '(min-width: 768px)' );
		const breakpointMatches = breakpoint.matches;
		
		return breakpointMatches;
	}

	let nonSliderContainers = getNonSliderContainers();
	let isDesktop = breakpointMatches();

	// update height on page load
	if (nonSliderContainers.length > 0 && isDesktop) {
		const nonSliderContainers = getNonSliderContainers();
		nonSliderContainers.forEach(nonSliderContainer => {
			const card = nonSliderContainer.getElementsByClassName('card')[0];
			setHeight(nonSliderContainer, card);
		});
	} 
	
	if (!nonSliderContainers.length) {
		const sliderContainers = Array.from(document.getElementsByClassName('related-content__list'));

		sliderContainers.forEach(sliderContainer => {
			unSetHeight(sliderContainer);
		});
	}

	// need to listen to window resize
	window.addEventListener('resize', _.throttle(() => {
		nonSliderContainers = getNonSliderContainers();
		isDesktop = breakpointMatches();
		
		if (nonSliderContainers.length > 0 && isDesktop) {
			const nonSliderContainers = getNonSliderContainers();
			nonSliderContainers.forEach(nonSliderContainer => {
				const card = nonSliderContainer.getElementsByClassName('card')[0];
				setHeight(nonSliderContainer, card);
			});
		}

		if (!nonSliderContainers.length) {
			const sliderContainers = Array.from(document.getElementsByClassName('related-content__list'));
	
			sliderContainers.forEach(sliderContainer => {
				unSetHeight(sliderContainer);
			});
		}
	}, 30));
};

export default updateHeightOfRelatedContent;